<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="イントラネットFW プラットフォームゲートウェイ  ゾーン接続設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row no-gutters justify="end" class="my-2" align="center">
              <v-btn
                v-if="zoneSelect.items.length < 2"
                color="primary"
                @click="toRegister"
              >
                ゾーン接続追加
              </v-btn>
            </v-row>
            <app-table
              primary-key="_primary"
              :fields="zoneSelect.fields"
              :items="zoneSelect.items"
              :per-page="-1"
              :tr-class="() => undefined"
            >
              <template #cell(srcZone)="data">
                {{
                  data.item.srcZoneId === pfgwZone.wvs2ZoneId ? "WVS2" : "KCPS"
                }}
              </template>
              <template #cell(arrow)> ⇒ </template>
              <template #cell(dstZone)="data">
                {{
                  data.item.dstZoneId === pfgwZone.wvs2ZoneId ? "WVS2" : "KCPS"
                }}
              </template>
              <template #cell(zoneDelete)="data">
                <v-btn color="primary" @click="toDelete(data.item)">
                  ゾーン接続削除
                </v-btn>
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >戻る
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { PfgwZone, PfgwZonePut } from "@/apis/PfgwZoneApi";
import IntranetFwPfgwZoneRelationDelete from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/pfgw/IntranetFwPfgwZoneRelationDelete.vue";
import IntranetFwPfgwZoneRelationRegister from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/pfgw/IntranetFwPfgwZoneRelationRegister.vue";

export default defineComponent({
  name: "IntranetFwPfgwZoneRelationList",
  props: {
    enumberAct: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      pfgwZone: {} as PfgwZone,
      zoneSelect: {
        fields: [
          {
            key: "srcZone",
            title: "送信元ゾーン",
            width: "130px",
          },
          { key: "arrow", title: "", width: "120px" },
          {
            key: "dstZone",
            title: "宛先ゾーン",
            width: "130px",
          },
          { key: "space", title: "", width: "200px" },
          { key: "zoneDelete", title: "", width: "180px" },
        ],
        items: [] as {
          _primary: string;
          srcZoneId: string;
          dstZoneId: string;
        }[],
      },
      /** 初期通信完了フラグ */
      isLoaded: false,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** データ取得 */
    async load() {
      this.pfgwZone = await this.$api.pfgwZoneRelation.getPfgwZone(
        this.enumberAct
      );
      this.zoneSelect.items = this.pfgwZone.zoneIdList.map((e) => ({
        _primary: `${e.srcZoneId}_${e.dstZoneId}`,
        ...e,
      }));
    },
    /** ゾーン接続削除 */
    async toDelete(item: { srcZoneId: string; dstZoneId: string }) {
      await this.$modal.show(IntranetFwPfgwZoneRelationDelete, {
        srcZoneId: item.srcZoneId,
        dstZoneId: item.dstZoneId,
        wvs2ZoneId: this.pfgwZone.wvs2ZoneId,
        kcpsZoneId: this.pfgwZone.kcpsZoneId,
      });
      this.zoneSelect.items.splice(
        this.zoneSelect.items.findIndex(
          (e) =>
            e.srcZoneId === item.srcZoneId && e.dstZoneId === item.dstZoneId
        ),
        1
      );
      const reqData: PfgwZonePut = {
        wvs2AddressList: this.pfgwZone.wvs2AddressList.map((e) => e.ipAddress),
        kcpsAddressList: this.pfgwZone.kcpsAddressList.map((e) => e.ipAddress),
        zoneIdList: this.zoneSelect.items,
        pfgwAddressKeyId: this.pfgwZone.pfgwAddressKeyId,
      };
      await this.$api.pfgwZoneRelation.putPfgwZone(this.enumberAct, reqData);
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    /** ゾーン接続追加モーダルを表示 */
    async toRegister() {
      await this.$modal.show(IntranetFwPfgwZoneRelationRegister, {
        enumberAct: this.enumberAct,
        pfgwZone: this.pfgwZone,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
  },
});
</script>
